// extracted by css-extract-rspack-plugin
export default {"SidebarContentMain":"Mgg6z","FooterButton":"j1RKn","SidebarContentRoot":"PTF9q","SidebarContentHeader":"mUaDL"};